var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$router.currentRoute.name == 'admin' && !_vm.$isMobile())?_c('Admin'):(this.$router.currentRoute.name == 'admin' && _vm.$isMobile())?_c('AdminMobile'):_c('App')}
var staticRenderFns = []

export { render, staticRenderFns }